class EfColorPicker {
    $onInit() {
        this.ngModelCtrl.$render = () => {
            this.color = this.ngModelCtrl.$viewValue
        }
    }

    get colors() {
        return [
            '16a085',
            '27ae60',
            '2980b9',
            '8e44ad',
            '34495e',
            'ffc107',
            'e67e22',
            'e74c3c',
            '7f8c8d'
        ]
    }

    selectColor(color) {
        this.color = color
        this.ngModelCtrl.$setViewValue(this.color)
    }

    iconColor(hex) {
        return cbk.blackOrWhiteBasedOnBackground(hex, 0.6)
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('efColorPicker', {
        controller: EfColorPicker,
        require: {
            ngModelCtrl: 'ngModel'
        },
        template: `
            <div>
                <span 
                    ng-repeat="color in $ctrl.colors" 
                    ng-click="$ctrl.selectColor(color)"
                    ng-class="{'is-selected': color == $ctrl.color}"
                    style="background: #{{color}};">
                    <i 
                        class="fa fa-check fade-animation" 
                        ng-show="color == $ctrl.color"
                        style="color: #{{$ctrl.iconColor(color)}};">
                    </i>
                </span>
            </div>
        `
    })
